/* ASIRI LA BOUTIQUE — Badges + WhatsApp v2.0 2026 */
(function () {
  'use strict';

  // —— CONFIG ——————————————————————————————————————————————
  var UMBRAL_CRITICO = 2;
  var UMBRAL_BAJO    = 5;
  var WA_NUMBER      = '56984977560';
  var WA_MSG         = encodeURIComponent('Hola! Vi productos en ASIRI La Boutique y quiero saber más 💕');

  var cache = {};

  function fetchInventory(handle, cb) {
    if (cache[handle] !== undefined) { cb(cache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var total = 0;
        if (data.variants) {
          data.variants.forEach(function (v) {
            if (v.available && v.inventory_quantity > 0) total += v.inventory_quantity;
          });
        }
        cache[handle] = total;
        cb(total);
      })
      .catch(function () { cache[handle] = 999; cb(999); });
  }

  function makeBadge(qty) {
    var span = document.createElement('span');
    span.className = 'asiri-stock-badge';
    span.style.cssText = [
      'display:inline-block',
      'color:#fff',
      'font-size:0.7rem',
      'font-weight:700',
      'padding:4px 10px',
      'border-radius:20px',
      'position:absolute',
      'top:8px',
      'left:8px',
      'z-index:10',
      'line-height:1.2',
      'letter-spacing:0.03em',
      'pointer-events:none'
    ].join(';');

    if (qty <= UMBRAL_CRITICO) {
      span.textContent = '🔥 ¡Último disponible!';
      span.style.background = 'linear-gradient(135deg,#006b8a,#00b4b4)';
      span.style.animation = 'pulse-badge 2s infinite';
    } else {
      span.textContent = '⚡ ¡Solo quedan ' + qty + '!';
      span.style.background = 'linear-gradient(135deg,#00b4b4,#00c9a7)';
    }
    return span;
  }

  function processCard(card) {
    if (card.dataset.asiriBadge) return;
    card.dataset.asiriBadge = '1';
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];
    fetchInventory(handle, function (qty) {
      if (qty > 0 && qty <= UMBRAL_BAJO) {
        var media = card.querySelector('.card__media, .media');
        if (media) {
          if (!media.style.position || media.style.position === 'static') {
            media.style.position = 'relative';
          }
          media.appendChild(makeBadge(qty));
        }
      }
    });
  }

  function scanCards() {
    document.querySelectorAll('.card-wrapper').forEach(processCard);
  }

  function init() {
    scanCards();
    var observer = new MutationObserver(function (mutations) {
      var needsScan = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (needsScan) scanCards();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();